define( [ "./selector-sizzle" ], function() {} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/selector.js
// module id = 15
// module chunks = 0